import Vue from "vue";
import url from "./apiUrls";
import {store} from "../../store/store";

export const courseEntityApi = new Vue({
  methods: {
    getAllCourses(token) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.courseEntity, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getCourseById(token, courseId) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      const getUrl = `${url.courseById}${courseId}`;
      return new Promise((resolve, reject) => {
        this.$http
          .get(getUrl, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    addCourse(token, courseData) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.addCourse, courseData, { headers: headerData })
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editCourse(token, courseData) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.courseEdit, courseData, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    deleteCourse(courseId) {
      const token = store.state.adminAuth.accessToken;
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      const getUrl = `${url.deleteCourse}${courseId}`;
      return new Promise((resolve, reject) => {
        this.$http
          .get(getUrl, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
